export function getCdnHost(): string {
  return '//front.embarkvet.com';
}

export function getImageHost(): string {
  return `${getCdnHost()}/img`;
}
